import React from 'react';
import { CASE_STATUS_COMPLETED } from './CaseConstants';
import CaseList from './CaseList';
import { APP_TERMS } from '../../app-terms';
const BREAD_CRUMBS = [
  { label: 'Case', to: '/user/case/completed' },
  { label: 'Completed', to: '/user/case/completed' },
];
const CompletedCases = () => {
  return (
    <div>
      <div>
        <CaseList
          title={APP_TERMS.completed_case_list_title}
          caseStatus={CASE_STATUS_COMPLETED}
          breadCrumbItems={BREAD_CRUMBS}
        />
      </div>
    </div>
  );
};

export default CompletedCases;
